const zh = {
  about: {
    desc:
      "我们的使命是开发无缝且用户友好的免费应用程序，以简化任务并在多个平台上提高生产力。我们致力于在不牺牲质量或用户体验的前提下，打造让日常生活更轻松的工具。",
    title: "关于我们",
    portfolio: {
      title: "我们的作品",
      mpc: {
        name: "结婚积分计算器",
        desc:
          "🃏 结婚纸牌游戏的最佳伴侣：结婚积分计算器（中心收集）移动应用！借助我们易于使用且可分享的界面，再也不用为计算分数而烦恼。",
        playStore: "在 Play 商店获取",
        appStore: "在 App 商店获取",
        web: "打开网页版应用",
      },
      led: {
        name: "LED & 霓虹招牌板",
        desc1:
          "将您的设备变成数字招牌。使用手机、平板电脑或投屏到智能电视，显示亮丽吸睛的讯息。",
        desc2: "非常适合演唱会和现场活动。",
        playStore: "在 Play 商店获取",
        appStore: "在 App 商店获取",
        web: "打开网页版应用",
      },
      tax: {
        name: "尼泊尔税务顾问",
        desc: "计算税费并寻找节税和省税的方法。",
        web: "打开网页版应用",
      },
      installOnMobile: "安装",
      openWebApp: "打开网页版应用",
    },
    team: {
      title: "我们的团队",
      manoj: {
        name: "Manoj Shrestha",
        role: "首席执行官（CEO）",
        desc: "拥有超过10年经验的 IT 商业专家，擅长利用信息技术解决商业问题。",
        profile: "查看简介",
      },
      pujan: {
        name: "Pujan Shrestha",
        role: "首席技术官（CTO）",
        desc:
          "拥有超过7年开发经验的技术专家，全面负责公司的技术事务，也是一名全栈开发者。",
        profile: "查看简介",
      },
      learnMore: "了解更多",
    },

    description: "欢迎使用我们的应用程序！我们致力于为您提供最佳体验。",
  },
  share: {
    title: "分享",
    description: "让你的朋友扫描二维码来安装应用！",
  },
  privacy: {
    title: "隐私政策",
    date: "2024年1月1日",
    description: "感谢您使用我们的应用。您的隐私对我们非常重要。本隐私政策说明了我们如何收集、使用和保护您的信息。",
    sections: {
      1: {
        title: "我们收集的信息",
        body: "个人信息：如您自愿提供，我们可能会收集您的姓名、电子邮件地址或其他联系方式。\n\n使用数据：我们会收集您如何与应用互动的信息，如访问的页面和使用的功能。\n\n设备信息：为提升性能和排查问题，我们可能会收集您的设备类型、操作系统和应用版本。"
      },
      2: {
        title: "我们如何使用您的信息",
        body: "用于提供和改进我们的服务。\n\n用于个性化用户体验。\n\n用于回应您的咨询和提供支持。\n\n在您同意的情况下，发送重要更新或推广信息。"
      },
      3: {
        title: "信息共享",
        body: "我们不会出售您的个人信息。我们可能会在以下情况下共享信息：\n\n与帮助我们运营应用的可信第三方服务。\n\n法律要求或为保护我们的合法权益。"
      },
      4: {
        title: "数据安全",
        body: "我们采取适当的技术和组织措施，防止您的数据被未经授权访问、丢失或滥用。"
      },
      5: {
        title: "您的权利",
        body: "您有权：\n\n访问我们持有的关于您的信息。\n\n请求更正或删除信息。\n\n随时撤回同意。"
      },
      6: {
        title: "第三方服务",
        body: "我们的应用可能会使用第三方服务（如分析或广告），这些服务有各自的隐私政策。建议您也查阅这些政策。"
      },
      7: {
        title: "政策变更",
        body: "我们可能会不时更新本政策。更改将在应用中发布并注明新的生效日期。"
      },
      8: {
        title: "联系我们",
        body: "如果您对本政策有任何疑问或担忧，请通过 shrestha.applications@gmail.com 联系我们。"
      }
    }
  },
  terms: {
    title: "使用条款",
    description: "在使用本应用前请仔细阅读这些条款。",
    sections: {
      1: {
        title: "接受条款",
        body: "访问或使用本应用即表示您同意遵守这些条款和条件。",
      },
      2: {
        title: "条款的修改",
        body:
          "我们有权随时更改、修改或修订本条款。更改后继续使用应用即表示您接受新的条款。",
      },
      3: {
        title: "用户责任",
        body:
          "您同意仅将应用用于合法目的，不从事可能损害应用或其他用户的任何活动。",
      },
      4: {
        title: "知识产权",
        body:
          "本应用中的所有内容、功能和功能性均为 Shrestha Apps 独有财产，受版权及其他法律保护。",
      },
      5: {
        title: "第三方服务",
        body:
          "本应用可能包含指向非我们所有或控制的第三方网站或服务的链接。我们对任何第三方网站的内容或做法不承担责任。",
      },
      6: {
        title: "免责声明",
        body:
          "本应用按“原样”和“可用”基础提供。我们不对应用的运行或可用性作出任何明示或暗示的保证。",
      },
      7: {
        title: "责任限制",
        body: "Shrestha Apps 对因您使用本应用而引起的任何损害概不负责。",
      },
      8: {
        title: "赔偿",
        body:
          "您同意就因您使用本应用而引起的任何索赔、损害或费用，向 Shrestha Apps 进行赔偿并使其免责。",
      },
      9: {
        title: "终止",
        body:
          "我们有权在任何时候、无须通知即终止或暂停您对应用的访问，原因不限。",
      },
      10: {
        title: "适用法律",
        body: "本条款受尼泊尔法律管辖并依其解释。",
      },
      11: {
        title: "联系我们",
        body: "如对本条款有任何疑问，请联系 shresthaapps@gmail.com。",
      },
      12: {
        title: "完整协议",
        body:
          "这些条款构成了您与 Shrestha Apps 之间关于您使用本应用的完整协议。",
      },
    },
    title: "条款和条件",
    description: "在使用本应用之前请仔细阅读我们的使用条款。",
    footer: {
      copyright: " {year} Shrestha Apps",
      allRightsReserved: "版权所有",
      tagline: "致力于开发让生活更便捷的应用程序。",
      nepal: "尼泊尔",
      japan: "日本",
      usa: "美国",
      email: "电子邮件",
    },
  },
  footer: {
    copyright: " {year} Shrestha Apps",
    allRightsReserved: "版权所有",
    tagline: "致力于开发让生活更便捷的应用程序。",
    nepal: "尼泊尔",
    japan: "日本",
    usa: "美国",
    email: "电子邮件",
  },
};

export default zh;
